module.exports = __webpack_public_path__ + "static/genius-1c691576c9fd77d25d7d6b9d24cc6cb6.png";